/* Trip-level components (S-02, S-03, S-08, W-02). */
.flat {
  margin: 0;
}
.muted {
  color: var(--color-text-secondary);
}
.faint {
  color: var(--color-text-tertiary);
}
.rule {
  display: inline-flex;
  align-items: center;
  gap: var(--dimension-space-2);
  white-space: nowrap;
  color: var(--color-text-primary);
}
.bar {
  width: 48px;
  height: 4px;
  background: var(--color-text-primary);
}
.barLarge {
  width: 64px;
  height: 8px;
}
.live {
  background: var(--color-surface-signal);
  box-shadow: inset 0 0 0 var(--dimension-line-hairline) var(--color-text-primary);
}
.arrow {
  font-size: 0.75em;
}
.codeTag {
  display: inline-flex;
}
.code {
  padding: var(--dimension-space-1) var(--dimension-space-2);
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.status {
  padding: var(--dimension-space-1) var(--dimension-space-2);
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
}
.card {
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
  background: var(--color-surface-base);
}
.band {
  position: relative;
  display: flex;
  align-items: flex-end;
  padding: var(--dimension-space-3);
  overflow: hidden;
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.noCover {
  background: var(--color-surface-sunken);
}
.withCover {
  height: 84px;
}
.liveBand.withCover {
  height: 112px;
}
.cover {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(1) contrast(1.05);
}
.liveBand .cover {
  filter: grayscale(1) contrast(1.25);
  mix-blend-mode: multiply;
}
.liveBand.withCover {
  background: var(--color-surface-signal);
}
.band > span {
  position: relative;
}
.cardBody {
  display: grid;
  gap: var(--dimension-space-2);
  padding: var(--dimension-space-4);
}
.titleRow {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--dimension-space-2);
}
.dates {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--dimension-space-1) var(--dimension-space-2);
}
.readout {
  display: grid;
  gap: 2px;
}
.trailing {
  text-align: right;
}
.tiles {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  margin: 0;
  border-top: var(--dimension-line-hairline) solid var(--color-border-hairline);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.tile {
  display: grid;
  gap: var(--dimension-space-1);
  padding: var(--dimension-space-3);
}
.tile + .tile {
  border-left: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.titleBlock {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0;
  border: var(--dimension-line-control) solid var(--color-text-primary);
}
.cell {
  display: grid;
  gap: var(--dimension-space-1);
  padding: var(--dimension-space-3);
  border-top: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.cell:nth-child(-n + 2) {
  border-top: 0;
}
.cell:nth-child(even) {
  border-left: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.meter {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: 3px;
}
.meter i {
  height: 8px;
  background: var(--color-border-hairline);
}
.meter i.filled {
  background: var(--color-text-primary);
}
.meter i.over {
  background: var(--color-status-danger);
}
.share {
  display: block;
  height: 10px;
  background: var(--color-surface-sunken);
}
.share i {
  display: block;
  height: 100%;
  background: var(--color-text-primary);
}
.tag {
  display: inline-block;
  padding: 1px var(--dimension-space-2);
}
.paid {
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.planned {
  color: var(--color-text-secondary);
  box-shadow: inset 0 0 0 var(--dimension-line-hairline) var(--color-border-control);
}
.dueGroup {
  display: inline-flex;
  align-items: stretch;
}
.stripes,
.hazardEdge::before {
  background: repeating-linear-gradient(
    -45deg,
    var(--color-text-on-signal) 0 3px,
    var(--color-surface-signal) 3px 6px
  );
}
.stripes {
  width: 10px;
}
.due {
  background: var(--color-surface-signal);
  color: var(--color-text-on-signal);
}
.dueDate {
  background: var(--color-surface-sunken);
  color: var(--color-text-primary);
}
.hazardEdge {
  position: relative;
}
.hazardEdge::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 6px;
}
